/* eslint-disable max-len */

import React, {PureComponent} from 'react';

import Api from 'lib/api';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap';

import styles from 'styles/index.scss';

const {cancelModalContainer, cancelModalButtons, cancelModalPrompt} = styles;
@connect(state => ({
  user: state.user
}))

//Zapier Web Hook
//https://hooks.zapier.com/hooks/catch/5025520/vonafl/
class CancelModal extends PureComponent {
  constructor(props) {
    super(props);
    const currentTime = new Date();
    this.state = {
      specialMessage: null, //full modal message, currently used when user decides to stay
      date: currentTime.getTime(),
      firstName: this.props.user.firstName || 'na',
      lastName: this.props.user.lastName || 'na',
      email: this.props.user.email || 'na',
      type: 'WLC Cancellation',
      q1: null,
      q2: null,
      q3: 'confirmed',
      supplement: null //one question can have a supplement answer to it in text format
    };
    this.messageLength = this.props.messageLength || 10000; //miliseconds of special message seen
    this.messageRedirect = this.props.messageRedirect || '/products/wlc/current-week'; //redirect after special message is seen
    this.suplemented = 'q1';
    this.handleChange = this.handleChange.bind(this);
    this.handleCancelation = this.handleCancelation.bind(this);
    this.handleRevert = this.handleRevert.bind(this);
  }

  handleChange(e) {
    if (e.target.type == 'checkbox') {
      this.setState({[e.target.name]: e.target.checked});
    } else {
      this.setState({[e.target.name]: e.target.value});
    }
  }
  //handles the full cancelation of subscription
  handleCancelation() {
    const opts = {removeHeaders: true};
    this.setState({
      specialMessage: {
        heading: 'We are sorry to see you go! ',
        body: 'Our team will follow up via email with a confirmation.',
        button: {
          text: 'Close',
          onClick: this.props.toggleCancel
        }
      }
    });

    if (this.state.supplement) {
      //if the question has a supplement input, then use it as the answer for the question
      this.setState({[this.suplemented]: this.state.supplement}, () => {
        Api.post('https://hooks.zapier.com/hooks/catch/5025520/vonafl/', this.state, null, opts);
      });
    } else {
      Api.post('https://hooks.zapier.com/hooks/catch/5025520/vonafl/', this.state, null, opts);
    }

    //call this store method for cancellation in backend
    this.props.cancelSubscription();
  }
  //handles when users changes his mind to not cancel
  handleRevert() {
    this.setState({
      specialMessage: {
        heading: 'Thanks for staying with WHOLE Life Club.',
        body:
          'We’re so glad that you’re part of our community of WHOLE Lifers! Please let us know if there is something we can do to make WLC even better!',
        button: {
          text: 'Go to the Weekly Guide',
          href: this.messageRedirect
        }
      }
    });
  }

  render() {
    const {
      isOpen,
      toggleCancel,
      cancelingProduct,
      cancelSuccess,
      cancelingNumber,
      cancelSubscription,
      cancelFail,
      fullPriceMonthly,
      fullPriceAnnual
    } = this.props;
    const {showMessage, specialMessage} = this.state;
    const formComplete = !!this.state.q1; //q3 is the confirmation question

    if (specialMessage) {
      return (
        <Modal isOpen={isOpen} centered>
          <ModalHeader>{specialMessage.heading}</ModalHeader>
          <ModalBody>{specialMessage.body}</ModalBody>
          <ModalFooter>
            <Container>
              <Row className="justify-content-end">
                <Button color="light" onClick={this.props.toggleCancel} className="mr-3">
                  Close
                </Button>
                <Button color="primary" href={specialMessage.button.href} onClick={specialMessage.button.onClick}>
                  {specialMessage.button.text}
                </Button>
              </Row>
            </Container>
          </ModalFooter>
        </Modal>
      );
    }

    return (
      <Modal isOpen={isOpen} centered size="lg">
        <ModalHeader>{cancelFail ? 'Whoops!' : 'Cancel your membership'}</ModalHeader>

        <ModalBody className={showMessage ? 'd-none ' : ''}>
          {cancelFail ? (
            <span>
              We weren't able to cancel this subscription for you. For immediate help, please call customer service.
            </span>
          ) : (
            <div>
              <Form>
                <FormGroup>
                  <Label for="q1">Why do you want to cancel your membership in WHOLE Life Club?</Label>
                  <Input onChange={e => this.handleChange(e)} type="select" name="q1" value={this.state.q1}>
                    <option value="" disabled={this.state.q1 !== null}>
                      -- Please select a reason --
                    </option>
                    <option>The content is too basic</option>
                    <option>The content is too advanced</option>
                    <option>The website is too complicated</option>
                    <option>I've had too many login issues</option>
                    <option>I don’t have enough time for it</option>
                    <option>It’s too expensive</option>
                    <option>I'd rather not say</option>
                    <option>Other</option>
                  </Input>
                </FormGroup>
                <FormGroup className={this.state.q1 === 'Other' ? '' : 'd-none'}>
                  <Label for="supplement">Please let us know your unique reason:</Label>
                  <Input
                    onChange={e => this.handleChange(e)}
                    type="textarea"
                    name="supplement"
                    value={this.state.supplement}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="q2">How could we have improved your experience with WHOLE Life Club? (Optional) </Label>
                  <Input onChange={e => this.handleChange(e)} type="textarea" name="q2" value={this.state.q2} />
                </FormGroup>
              </Form>
              <p>
                By canceling you’ll lose all of your access to the delicious recipes, action checklists, action of the
                week videos, action hours, and the amazing community. And we want to be sure you know that since the
                time you joined, the price has gone up to ${fullPriceMonthly}/month (${fullPriceAnnual}/year). So even
                if you aren't fully using your membership right now, if you think you might some day, this could be a
                great reason to keep it active. And, while we'll miss you terribly if you go, we support you in doing
                what’s best for you.
              </p>
              <p>Are you really, really sure? Or will you give us one more chance to work things out?</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Container>
            <Row className="justify-content-end">
              <Col xs="12" md="auto" className="order-md-2">
                <Button
                  color="light"
                  disabled={!formComplete}
                  onClick={this.handleCancelation}
                  style={{cursor: formComplete ? 'pointer' : 'not-allowed'}}
                >
                  Yes, I understand. Cancel my subscription.
                </Button>
              </Col>
              <Col xs="12" md="auto" className="order-md-1 mt-3 mt-md-0">
                <Button color="primary" onClick={this.handleRevert} style={{cursor: 'pointer'}}>
                  Nevermind, I want to stay in the club.
                </Button>
              </Col>
            </Row>
          </Container>
        </ModalFooter>
      </Modal>
    );
  }
}

CancelModal.propTypes = {};

export default withRouter(CancelModal);
